<style lang="less">
@import "../main.less";
</style>

<template>
  <div
    ref="scrollCon"
    @DOMMouseScroll="handlescroll"
    @mousewheel="handlescroll"
    class="tags-outer-scroll-con"
  >
    <div class="maskLayer"></div>
    <div class="close-all-tag-con">
      <Dropdown transfer @on-click="handleTagsOption">
        <Icon type="android-settings" size="18"></Icon>
        <Icon type="arrow-down-b" size="12" style="margin-left: 2px"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem name="clearAll">关闭所有</DropdownItem>
          <DropdownItem name="clearOthers">关闭其他</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <div class="help-tag-con">
      <Dropdown transfer @on-click="helpTagsOption">
        <Icon type="help-circled" size="18"></Icon>
        <Icon type="arrow-down-b" size="12" style="margin-left: 2px"></Icon>
        <DropdownMenu slot="list">
          <DropdownItem
            v-for="item in helpObj"
            :key="item.id"
            :name="item.id"
            >{{ item.id + "." + item.txt }}</DropdownItem
          >
        </DropdownMenu>
      </Dropdown>
    </div>
    <div
      ref="scrollBody"
      class="tags-inner-scroll-body"
      :style="{ left: tagBodyLeft + 'px' }"
    >
      <transition-group name="taglist-moving-animation">
        <!--  :style="{border-right:1px solid #cccccc;borderRight:item.children?(item.children[0].name===currentPageName?'0':'1px solid #cccccc'):(item.name===currentPageName?'0':'1px solid #cccccc')}" -->
        <Tag
          :class="{
            tagLabel: item.children
              ? item.children[0].name === currentPageName
                ? false
                : true
              : item.name === currentPageName
              ? false
              : true,
          }"
          v-for="item in pageTagsList"
          ref="tagsPageOpened"
          :key="item.name"
          :name="item.name"
          @on-close="closePage"
          @click.native="linkTo(item)"
          :closable="item.name === 'home_index' ? false : true"
          :style="[{border:'0',borderadius: '0px'},{minWidth:item.name == 'home_index' ?'80px':''}]"
          :color="
            item.children
              ? item.children[0].name === currentPageName
                ? '#1776d3'
                : '#1e89e5'
              : item.name === currentPageName
              ? '#1776d3'
              : '#1e89e5'
          "
          >{{ itemTitle(item) }}</Tag
        >
      </transition-group>
    </div>
    <!-- 全局帮助提示 -->
    <transition name="fade">
    <div class="helpBox" v-show="modalHelp" @click="closeHelp">
      <img :src="nowHelp.src" width="100%" height="100%" />
      <!-- <Icon type="close-round" size="large"></Icon> -->
    </div>
    </transition>
  </div>
</template>

<script>
import Vue from "vue";
// import VueI18n from "vue-i18n";
// Vue.use(VueI18n);
export default {
  name: "tagsPageOpened",
  data() {
    return {
      currentPageName: this.$route.name,
      tagBodyLeft: 0,
      refsTag: [],
      tagsCount: 1,
      // 帮助说明
      helpObj: [
        { id: "1", src: "./static/help/addmeeting.gif", txt: "如何创建会议" },
        { id: "2", src: "./static/help/editmeeting.gif", txt: "如何完善会议" },
        { id: "3", src: "./static/help/user.gif", txt: "如何进行人员排座" },
        { id: "4", src: "./static/help/startmeeting.gif", txt: "如何开始、结束会议" },
        { id: "5", src: "./static/help/nodesys.gif", txt: "如何控制会议终端" },
        { id: "6", src: "./static/help/addvote.gif", txt: "如何发起投票" },
      ],
      // 当前查看的帮助内容
      nowHelp: {src:"",txt:""},
      // 帮助窗口
      modalHelp: false,
    };
  },
  props: {
    pageTagsList: Array,
    beforePush: {
      type: Function,
      default: (item) => {
        return true;
      },
    },
  },
  computed: {
    title() {
      return this.$store.state.app.currentTitle;
    },
    tagsList() {
      return this.$store.state.app.pageOpenedList;
    },
  },
  methods: {
    itemTitle(item) {
      if (typeof item.title === "object") {
        return this.$t(item.title.i18n);
      } else {
        return item.title;
      }
    },
    closePage(event, name) {
      let pageOpenedList = this.$store.state.app.pageOpenedList;
      let lastPageObj = pageOpenedList[0];
      if (this.currentPageName === name) {
        let len = pageOpenedList.length;
        for (let i = 1; i < len; i++) {
          if (pageOpenedList[i].name === name) {
            if (i < len - 1) {
              lastPageObj = pageOpenedList[i + 1];
            } else {
              lastPageObj = pageOpenedList[i - 1];
            }
            break;
          }
        }
      } else {
        let tagWidth = event.target.parentNode.offsetWidth;
        this.tagBodyLeft = Math.min(this.tagBodyLeft + tagWidth, 0);
      }
      this.$store.commit("removeTag", name);
      this.$store.commit("closePage", name);
      pageOpenedList = this.$store.state.app.pageOpenedList;
      localStorage.pageOpenedList = JSON.stringify(pageOpenedList);
      if (this.currentPageName === name) {
        this.linkTo(lastPageObj);
      }
    },
    linkTo(item) {
      let routerObj = {};
      routerObj.name = item.name;
      if (item.argu) {
        routerObj.params = item.argu;
      }
      if (item.query) {
        routerObj.query = item.query;
      }
      if (this.beforePush(item)) {
        this.$router.push(routerObj);
      }
    },
    handlescroll(e) {
      var type = e.type;
      let delta = 0;
      if (type === "DOMMouseScroll" || type === "mousewheel") {
        delta = e.wheelDelta ? e.wheelDelta : -(e.detail || 0) * 40;
      }
      let left = 0;
      if (delta > 0) {
        left = Math.min(0, this.tagBodyLeft + delta);
      } else {
        if (
          this.$refs.scrollCon.offsetWidth - 120 <
          this.$refs.scrollBody.offsetWidth
        ) {
          if (
            this.tagBodyLeft <
            -(
              this.$refs.scrollBody.offsetWidth -
              this.$refs.scrollCon.offsetWidth +
              120
            )
          ) {
            left = this.tagBodyLeft;
          } else {
            left = Math.max(
              this.tagBodyLeft + delta,
              this.$refs.scrollCon.offsetWidth -
                this.$refs.scrollBody.offsetWidth -
                120
            );
          }
        } else {
          this.tagBodyLeft = 0;
        }
      }
      this.tagBodyLeft = left;
    },
    handleTagsOption(type) {
      if (type === "clearAll") {
        this.$store.commit("clearAllTags");
        this.$router.push({
          name: "home_index",
        });
      } else {
        this.$store.commit("clearOtherTags", this);
      }
      this.tagBodyLeft = 0;
    },
    // 帮助
    helpTagsOption(type) {
      this.nowHelp=this.helpObj[type-1];
      this.modalHelp = true;
    },
    // 关闭帮助
    closeHelp(){
      this.nowHelp={};
      this.modalHelp = false;
    },
    moveToView(tag) {
      if (tag.offsetLeft < -this.tagBodyLeft) {
        // 标签在可视区域左侧
        this.tagBodyLeft = -tag.offsetLeft + 50;
      } else if (
        tag.offsetLeft + 10 > -this.tagBodyLeft &&
        tag.offsetLeft + tag.offsetWidth <
          -this.tagBodyLeft + this.$refs.scrollCon.offsetWidth - 120
      ) {
        // 标签在可视区域
        this.tagBodyLeft = Math.min(
          0,
          this.$refs.scrollCon.offsetWidth -
            120 -
            tag.offsetWidth -
            tag.offsetLeft -
            20
        );
      } else {
        // 标签在可视区域右侧
        this.tagBodyLeft = -(
          tag.offsetLeft -
          (this.$refs.scrollCon.offsetWidth - 100 - tag.offsetWidth) +
          20
        );
      }
    },
  },
  mounted() {
    this.refsTag = this.$refs.tagsPageOpened;
    setTimeout(() => {
      this.refsTag.forEach((item, index) => {
        if (this.$route.name === item.name) {
          let tag = this.refsTag[index].$el;
          this.moveToView(tag);
        }
      });
    }, 1); // 这里不设定时器就会有偏移bug
    this.tagsCount = this.tagsList.length;
  },
  watch: {
    $route(to) {
      this.currentPageName = to.name;
      this.$nextTick(() => {
        this.refsTag.forEach((item, index) => {
          if (to.name === item.name) {
            let tag = this.refsTag[index].$el;
            this.moveToView(tag);
          }
          if (to.name == "home_index") {
            this.tagBodyLeft = 0;
          }
        });
      });
      this.tagsCount = this.tagsList.length;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/views/main-components/tags-page-opened.vue